// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthFormDialog__content","inner":"AuthFormDialog__inner","align":"AuthFormDialog__align","close":"AuthFormDialog__close","cross":"AuthFormDialog__cross"};